import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { GetParametersForImport$ } from "../schemas/schemas_0";
export { $Command };
export class GetParametersForImportCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("TrentService", "GetParametersForImport", {})
    .n("KMSClient", "GetParametersForImportCommand")
    .sc(GetParametersForImport$)
    .build() {
}
